module.exports = __webpack_public_path__ + "static/media/ly.25d53dde.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ly.svg
// module id = 2147
// module chunks = 0